import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ColorWarning = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M22 8.90902V16.091C22 17.267 21.3726 18.359 20.3583 18.9575L14.147 22.559C13.1326 23.147 11.8778 23.147 10.853 22.559L4.64172 18.9575C3.62741 18.3695 3 17.2775 3 16.091V8.90902C3 7.73303 3.62741 6.64098 4.64172 6.04249L10.853 2.441C11.8674 1.853 13.1222 1.853 14.147 2.441L20.3583 6.04249C21.3726 6.64098 22 7.72253 22 8.90902Z",
                fill: "#C3B3FC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.5052 14.3375C12.0765 14.3375 11.721 13.9805 11.721 13.55V8.03749C11.721 7.60699 12.0765 7.24999 12.5052 7.24999C12.934 7.24999 13.2895 7.60699 13.2895 8.03749V13.55C13.2895 13.9805 12.934 14.3375 12.5052 14.3375Z",
                fill: "#6942F8"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12.5052 18.0125C12.3693 18.0125 12.2334 17.9809 12.1079 17.9284C11.9719 17.8759 11.8673 17.8025 11.7628 17.708C11.6687 17.603 11.5955 17.4875 11.5328 17.3615C11.4805 17.2355 11.4596 17.099 11.4596 16.9625C11.4596 16.6895 11.5641 16.4164 11.7628 16.2169C11.8673 16.1224 11.9719 16.049 12.1079 15.9965C12.4948 15.8285 12.9549 15.9229 13.2477 16.2169C13.3418 16.3219 13.415 16.4269 13.4672 16.5634C13.5195 16.6894 13.5509 16.826 13.5509 16.9625C13.5509 17.099 13.5195 17.2355 13.4672 17.3615C13.415 17.4875 13.3418 17.603 13.2477 17.708C13.049 17.9075 12.7876 18.0125 12.5052 18.0125Z",
                fill: "#6942F8"
            })
        ]
    });
};
